var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3818_33265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50792 23.6834L24.6575 13.9294C25.1775 13.6494 25.527 13.2574 25.7058 12.7574C25.8847 12.2574 25.8847 11.7574 25.7058 11.2574C25.527 10.7574 25.1786 10.3664 24.6586 10.0844L7.50896 0.330359C7.05344 0.0493588 6.55008 -0.0526396 5.99784 0.0253604C5.4456 0.10436 4.97448 0.338359 4.58448 0.729359C4.19448 1.11936 4 1.62836 4 2.25336V21.7614C4 22.3244 4.1872 22.8084 4.56056 23.2144C4.93392 23.6214 5.39672 23.8714 5.94896 23.9644C6.50016 24.0594 7.02016 23.9644 7.50896 23.6844L7.50792 23.6834ZM6.48456 21.5034C6.38784 21.4564 6.33896 21.3864 6.33896 21.2924V2.72236C6.33896 2.62836 6.38784 2.55836 6.48456 2.51136C6.58232 2.46436 6.68008 2.45636 6.7768 2.48736L23.0507 11.7724C23.1485 11.8354 23.1963 11.9134 23.1963 12.0074C23.1963 12.1014 23.1485 12.1794 23.0507 12.2414L6.7768 21.5264C6.68008 21.5584 6.58128 21.5504 6.48456 21.5034Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3818_33265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.772a1bf63a1b3ec1b38d8f9650944f23.svg";
export { ForwardRef as ReactComponent };